import React from 'react'
import './galery.css'
import img1 from '../../assets/img1.png'
import img2 from '../../assets/img2.png'
import img3 from '../../assets/img3.png'
import img4 from '../../assets/img4.png'
import img5 from '../../assets/img5.png'
import img6 from '../../assets/img6.png'
import img7 from '../../assets/img7.png'
import img8 from '../../assets/img8.png'
import img9 from '../../assets/img9.png'
import img10 from '../../assets/img10.png'
import img11 from '../../assets/img11.png'
import img12 from '../../assets/img12.png'
import img13 from '../../assets/img13.png'
import img14 from '../../assets/img14.png'
import img15 from '../../assets/img15.png'
import img16 from '../../assets/img16.png'
import img17 from '../../assets/img17.png'
import img18 from '../../assets/img18.png'
import img19 from '../../assets/img19.png'
import img20 from '../../assets/img20.png'
import img21 from '../../assets/img21.png'
import img22 from '../../assets/img22.png'
import img23 from '../../assets/img23.png'
import img24 from '../../assets/img24.png'
import img25 from '../../assets/img25.png'
import img26 from '../../assets/img26.png'
import img27 from '../../assets/img27.png'
import img28 from '../../assets/img28.png'
import img29 from '../../assets/img29.png'
import img30 from '../../assets/img30.png'
import img31 from '../../assets/img31.png'
import img32 from '../../assets/img32.png'
import img33 from '../../assets/img33.png'
import img34 from '../../assets/img34.png'
import img35 from '../../assets/img35.png'
import img36 from '../../assets/img36.png'
import img37 from '../../assets/img37.png'
import img38 from '../../assets/img38.png'
import img39 from '../../assets/img39.png'
import img40 from '../../assets/img40.png'
import img41 from '../../assets/img41.png'
import img42 from '../../assets/img42.png'
import img43 from '../../assets/img43.png'
import img44 from '../../assets/img44.png'
import img45 from '../../assets/img45.png'

import { useState } from 'react'
import Pagination from './Pagination'

const data = [
  {
    id: 1,
    image: img1,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 2,
    image: img2,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 3,
    image: img3,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 4,
    image: img4,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 5,
    image: img5,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 6,
    image: img6,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 7,
    image: img7,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 8,
    image: img8,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 9,
    image: img9,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 10,
    image: img10,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 11,
    image: img11,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 12,
    image: img12,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 13,
    image: img13,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 14,
    image: img14,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 15,
    image: img15,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 16,
    image: img16,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 17,
    image: img17,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 18,
    image: img18,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 19,
    image: img19,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 20,
    image: img20,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 21,
    image: img21,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 22,
    image: img22,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 23,
    image: img23,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 24,
    image: img24,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 25,
    image: img25,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 26,
    image: img26,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 27,
    image: img27,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 28,
    image: img28,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 29,
    image: img29,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 30,
    image: img30,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 31,
    image: img31,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 32,
    image: img32,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 33,
    image: img33,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 34,
    image: img34,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 35,
    image: img35,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 36,
    image: img36,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 37,
    image: img37,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 38,
    image: img38,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 39,
    image: img39,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  ,
  {
    id: 40,
    image: img40,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 41,
    image: img41,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  ,
  {
    id: 42,
    image: img42,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 43,
    image: img43,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 44,
    image: img44,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
  {
    id: 45,
    image: img45,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
]

export default function Galery() {
  const [currentPage, setCurrentPage] = useState(1)
  const [PostPerPage, setPostPerPage] = useState(9)
  const lastPostIndex = currentPage * PostPerPage
  const firstPostIndex = lastPostIndex - PostPerPage
  const currentPosts = data.slice(firstPostIndex, lastPostIndex)
  return (
    <section id='galery'>
      <h2>Mes recentes réalisations</h2>
      <div className='galeri_container'>
        {currentPosts.map(({ id, image }) => {
          return (
            <article key={id} className=''>
              <div>
                <img src={image} alt='project' />
              </div>
              {/* <h3>{title}</h3>
              <div className='portofolio_item-cta'>
                <a className='btn'>Projet</a>
                <a href={demo} className='btn btn-primary' target='_blank'>
                  Demo
                </a>
              </div> */}
            </article>
          )
        })}{' '}
        <br />
        <Pagination
          className='paginaton_btns'
          totalPosts={data.length}
          postsPerPage={PostPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        ></Pagination>
      </div>
    </section>
  )
}
